import AppContextInterface from './AppContextInterface'

export const initialContextState: AppContextInterface = {
  logSplunk: (error: any | Error, moreInfo: any) => {
    console.log('Splunk client', error, moreInfo)
  }
}
